import { useMemo } from "react";

import {
    applyRoofPitchToScope,
    sanitizeVariableName,
} from "../../../utils/formulaScope";
import { ROOF_MEASUREMENT_KEYS } from "../../../constants/roofMeasurements";
import { useEstimateContractContextManager } from "./";

export function useCalculationScope() {
    const { values, initLoading } = useEstimateContractContextManager();

    const scope = useMemo(
        () => buildScope(values.measurements, values.attributes),
        [values.measurements, values.attributes],
    );

    return {
        scope,
        loading: initLoading,
    };
}

function buildScope(measurements: any, attributes: any) {
    let scope: any = {};

    for (const key of ROOF_MEASUREMENT_KEYS) {
        const entry = measurements[key];
        scope[sanitizeVariableName(key)] = Number(
            entry?.Actual ?? entry?.Calculated ?? 0,
        );
    }

    for (const [key, value] of Object.entries(attributes || {})) {
        if (key === "RoofPitch") {
            const roofPitch = applyRoofPitchToScope(value);
            scope = { ...scope, ...roofPitch };
            continue;
        }

        scope[sanitizeVariableName(key)] = value;
    }

    return scope;
}
